import React from 'react';
import { Link } from 'react-router-dom';
import { REALMS } from '../data/realms';

export const RealmMenu = ({ hash = '', onPick, className = '' }) => (
  <div className={`realm-menu ${className}`} role="menu" data-testid="realm-menu">
    {REALMS.map((realm) => (
      <Link
        key={realm.slug}
        to={`/realm/${realm.slug}${hash}`}
        role="menuitem"
        className="realm-menu-item"
        onClick={onPick}
        data-testid={`realm-menu-${realm.slug}`}
      >
        <span className="realm-menu-numeral">Realm {realm.numeral}</span>
        <span className="realm-menu-name">{realm.name}</span>
        <span className="realm-menu-sub">{realm.subtitle}</span>
      </Link>
    ))}
  </div>
);
